import type { ExampleQuestion } from "@/types"

import { Card } from "@/components/ui/card"

export type ExampleQuestionsProps = {
  exampleQuestions: ExampleQuestion[]
  onClick: (value: string) => void
}

export function ExampleQuestions({ exampleQuestions, onClick }: ExampleQuestionsProps) {
  return (
    <section className="flex h-full flex-row items-center gap-2 overflow-x-auto px-4 pb-2 lg:flex-col lg:overflow-x-visible lg:px-0 lg:pb-0 xl:flex-row xl:justify-center">
      {exampleQuestions.map((question) => (
        <Card
          key={question.value}
          className="border-border/50 card-interactive focus-visible:ring-ring flex h-[100px] w-[220px] min-w-[220px] cursor-pointer items-center justify-center border px-4 py-3 shadow-sm focus-visible:ring-2 focus-visible:outline-none lg:h-[120px] lg:w-full lg:max-w-[280px] lg:min-w-0 xl:h-[120px] xl:flex-1"
          role="button"
          tabIndex={0}
          onClick={() => onClick(question.value)}
          onKeyDown={(event) => {
            if (event.key !== "Enter" && event.key !== " ") return
            event.preventDefault()
            onClick(question.value)
          }}
        >
          <p className="text-center text-sm leading-relaxed">{question.text}</p>
        </Card>
      ))}
    </section>
  )
}
